export default __webpack_public_path__ + "static/media/bank.eaf002f8.svg";